import { useSelector } from '@/store'
import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { getI18nRefundLogisticsInfo } from '@/services/api'
import { useI18nText } from '@/utils/common'
import { REFUND_SOURCE_OPTIONS, REFUND_TYPE_ENUMS } from '@/containers/Refund/constants'
import { useMemo } from 'react'

/** 搜索项需要的list,options都放在这里！ 跟tagList用同一个！ */
export function useGetOptionsAndMap() {
  const { getI18nText } = useI18nText()
  const { t } = useTranslation()

  // ===============》 物流渠道相关 《=================
  /**
   * 请求授权仓库下的物流渠道列表
   * 需要根据渠道商，更新物流渠道
   */
  const { data: expressList = [] } = useSWR('/api/logistics/list-refund-logistics', async () => {
    const { data } = await getI18nRefundLogisticsInfo({})
    return data
  })

  const channelMap = {}

  expressList?.forEach?.((item) => {
    channelMap[item.logisticsId] = getI18nText(item.logisticsNames)
  })

  // ===============》 物流状态相关 《=================

  const logisticStatusList = useSelector((state) => state.common?.enums?.outboundLogisticsStatus?.list || [])

  const logisticStatusOptions = logisticStatusList?.map((item) => ({ label: t(`logistic.status.${item.code}`), value: item.code }))

  const logisticStatusMap = {}
  logisticStatusList?.forEach((item) => {
    logisticStatusMap[item.code] = t(`logistic.status.${item.code}`)
  })

  // ===============》 入库状态相关 《=================

  const inboundMainStatusList = useSelector((state) => state.common?.enums?.inboundMainStatus.list || []).filter((i) => i.code !== 'created' && i.code !== 'cancelled')
  const inboundMainStatusOptions = inboundMainStatusList?.map((item) => ({ label: t(`enums.inboundMainStatus.${item.code}`), value: item.code }))
  const inboundMainStatusMap = {}
  inboundMainStatusList?.forEach((item) => {
    inboundMainStatusMap[item.code] = t(`enums.inboundMainStatus.${item.code}`)
  })

  // ===============》 退货地址类型相关 《=================

  const warehouseInfoList = useSelector((state) => state.common?.warehouseInfoList || [])
  const warehouseOptions = warehouseInfoList?.map((item) => ({ label: getI18nText(item.warehouseNames), value: item.warehouseId }))
  const warehouseMap = {
    __customAddress: t('refund.list.refundAddressType.custom'),
  }
  warehouseInfoList?.forEach((item) => {
    warehouseMap[item.warehouseId] = getI18nText(item.warehouseNames)
  })

  // ===============》 待处理原因相关 《=================
  const refundFailReasonSearchList = useSelector((state) => state.common?.enums?.refundFailReasonSearch?.list || [])
  const refundFailReasonSearchOptions = refundFailReasonSearchList?.map((item) => ({ label: t(`enums.outboundFailReason.title.${item.code}`), value: item.code }))
  const refundFailReasonSearchMap = {}
  refundFailReasonSearchList?.forEach((item) => {
    refundFailReasonSearchMap[item.code] = t(`enums.outboundFailReason.${item.code}`)
  })

  // ===============》 退货类型相关 《=================
  const refundTypeOptions = Object.keys(REFUND_TYPE_ENUMS).map((item) => {
    return {
      label: t(`common.refundType.${item}`),
      value: item,
    }
  })
  const refundTypeMap = refundTypeOptions.reduce((cur, self) => {
    cur[self.value] = self.label
    return cur
  }, {})

  const refundSourceOptions = useMemo(() => REFUND_SOURCE_OPTIONS.map((i) => ({ value: i.value, label: t(i.label) })), [t])

  return {
    channelMap,
    expressList,
    logisticStatusOptions,
    logisticStatusMap,
    inboundMainStatusOptions,
    inboundMainStatusMap,
    warehouseOptions,
    warehouseMap,
    refundFailReasonSearchOptions,
    refundFailReasonSearchMap,
    refundTypeOptions,
    refundTypeMap,
    refundSourceOptions,
  }
}
